import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { CartProvider } from "@/context/CartContext";
import Nav from "@/components/Nav";
import KillGate from "@/components/KillGate";
import Home from "@/pages/Home";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <KillGate>
        <CartProvider>
          <BrowserRouter>
            <Nav />
            <main className="app-main">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/product/:slug" element={<ProductDetail />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout/success" element={<CheckoutSuccess />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
            </main>
          </BrowserRouter>
        </CartProvider>
      </KillGate>
    </div>
  );
}

export default App;
